import { render, staticRenderFns } from "./selectCustomerComp.vue?vue&type=template&id=b69327f0"
import script from "./selectCustomerComp.ts?vue&type=script&lang=js&external"
export * from "./selectCustomerComp.ts?vue&type=script&lang=js&external"
import style0 from "./selectCustomerComp.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports